var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgD(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "35.97mm",
    height: "35.973mm",
    viewBox: "0 0 35.97 35.973",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-100.74 -78.849)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m136.71 95.129v3.4184c0 8.9879-7.2866 16.275-16.275 16.275h-16.73c-1.6378 0-2.966-1.3282-2.966-2.966v-30.041c0-1.6378 1.3282-2.966 2.966-2.966h16.73c8.9905 0.0053 16.275 7.2919 16.275 16.28zm-18.201-8.1174c0-0.58473-0.4736-1.0583-1.0583-1.0583s-1.0583 0.4736-1.0583 1.0583v19.653c0 0.58473 0.4736 1.0583 1.0583 1.0583s1.0583-0.4736 1.0583-1.0583z",
    fill: "#0083c1",
    strokeWidth: 0.26458
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgD);
export default __webpack_public_path__ + "static/media/d.fd6361829d8b576c4b3696ef2febcbb6.svg";
export { ForwardRef as ReactComponent };